<template>
  <v-snackbar :timeout="getNotification.timeout" v-model="getNotification.active" :multi-line="getNotification.mode === 'multi-line'"
      :vertical="getNotification.mode === 'vertical'" tile :color="getNotification.color">
    {{getNotification.text}}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="closeNotification">
        {{$t('close')}}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "Notifications",
  computed: {
    ...mapGetters({
      'getNotification': 'settings/getNotification',
    }),
  },
  methods: {
    ...mapMutations({
      'setNotification': 'settings/setNotification',
    }),
    async closeNotification() {
      var notification = JSON.parse(JSON.stringify(this.getNotification))
      notification.active = false
      await this.setNotification(notification)
    }
  }
}
</script>

<style scoped>

</style>